// Libraries
import { action, computed, observable } from "mobx";

// Core
import { ViewModelBase } from "../../Core/ViewModels/ViewModelBase";
import { FieldType } from "../../Core/Utils/Utils";

// Custom
import { CardPaymentModel } from "../Models/CardPaymentModel";
import { StoresInstance } from "Custom/Stores";
import { GlobalSettingType } from "Custom/Models/Enums/GlobalSettingType";

export enum CARD_TYPE {
    Visa = "visa",
    Mastercard = "mastercard",
}

export class CardPaymentViewModel extends ViewModelBase<CardPaymentModel> {
    @observable
    public isCardComplete: boolean = false;

    constructor() {
        super(new CardPaymentModel());
        this.setDecorators(CardPaymentModel);
    }

    @computed
    public get stripePaymentProvider() {
        const setting = StoresInstance.domain.AccountStore.getSettingByType(GlobalSettingType.PaymentProvider);
        return setting && setting.settingValue === "stripe";
    }

    @action
    public setCardComplete(complete: boolean) {
        this.isCardComplete = complete;
    }

    // #region Server Properties and Actions
    // #endregion Server Properties and Actions

    // #region Bolierplate

    public afterUpdate: undefined;

    public beforeUpdate(fieldName: keyof FieldType<CardPaymentModel>, value: any): any {
        return value;
    }

    public isFieldValid(fieldName: keyof FieldType<CardPaymentModel>, value: any): boolean {
        let { isValid, errorMessage } = this.validateDecorators(fieldName);

        // With Stripe Elements, we only need to validate the name field
        if (fieldName === "name") {
            // Only validate if the field has been touched
            if (this.getTouched(fieldName)) {
                isValid = value && value.trim().length > 0;
                if (!isValid) {
                    errorMessage = "Name is required";
                }
            } else {
                // If not touched, consider it valid until user interacts
                isValid = true;
                errorMessage = "";
            }
        }

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public areAllRequiredFieldsFilled(): boolean {
        // Check if name is filled
        if (!this.model.name || this.model.name.trim().length === 0) {
            return false;
        }

        // Check if card is complete
        if (!this.isCardComplete) {
            return false;
        }

        return true;
    }

    // #endregion Boilerplate
}
